import { request } from './client'
import type { Knowledge, SearchHit } from './types'

/** 在知识库里找相关段落（与问答同一套检索）。 */
export const searchKnowledge = (query: string, knowledgeBaseIds: string[]) =>
  request<{ data: SearchHit[] }>('/knowledge-search', { body: { query, knowledge_base_ids: knowledgeBaseIds } }).then((r) => r.data ?? [])

/** 按文件名、标题找资料。 */
export const searchByName = (keyword: string, limit = 8) =>
  request<{ data: Knowledge[]; has_more?: boolean; total?: number }>('/knowledge/search', { query: { keyword, offset: 0, limit } }).then((r) => r.data ?? [])

export interface MessageHit {
  request_id: string
  session_id: string
  session_title: string
  query_content: string
  answer_content: string
  created_at: string
}

/** 在以前的对话里找。 */
export const searchMessages = (query: string) =>
  request<{ data: { items: MessageHit[]; total: number } }>('/messages/search', { body: { query, mode: 'hybrid', limit: 20 } }).then((r) => r.data?.items ?? [])
